import jwt_decode from "jwt-decode";
import AxiosLibWithHeader2 from "../../Library/AxiosLibWithHeader2";
import axios from "axios";

const AuthToken = localStorage.getItem("AuthToken");
const AuthDecode = AuthToken ? jwt_decode(AuthToken) : [];

const Request2Estes = async (param) => {
  const keys = {
    AppId: AuthDecode.AppID,
    AppEnv: AuthDecode.AppEnv,
    Secretkey: AuthDecode.secretkey,
  };

  const postData = {
    keys: keys,
    body: param,
  };

  const results = await AxiosLibWithHeader2(
    postData,
    "app/api/req-module"
  ).then((response) => {
    if (response.error) {
      return { loading: false, data: [], message: response.error };
    } else if (response.result && response.result === "error") {
      const code_api = response?.response?.message?.code || "";
      const code_msg = response?.response?.message?.user || "";
      return {
        loading: false,
        data: [],
        message:
          code_api === "900908"
            ? "Access to the API service is restricted for this application."
            : code_msg,
      };
    } else if ("message" in response.response) {
      const msg = response.response.message.user;
      return { loading: false, data: [], message: msg };
    } else {
      const data = response.response.data;
      return { loading: false, data: data, message: "" };
    }
  });

  return results;
};

const GET_ENROLLMENT_PROCESS = async (param) => {
  const param_post = {
    parameters: param,
    target_data: "GET_ENROLLMENT_PROCESS",
  };
  const results = await Request2Estes(param_post);

  return results;
};

const GET_ENROLLMENT_PROCESS_BY_ID = async (param) => {
  const param_post = {
    parameters: param,
    target_data: "GET_ENROLLMENT_PROCESS_BY_ID",
  };
  const results = await Request2Estes(param_post);

  return results;
};

const ConsumerKey =
  "Basic Y2xpZW50OmtqN0tmclVtOXNKOFdxQ0hnZE5aUWFuU0JNdkUzdWJw";

const POST_REQUEST_DOC_MULTIPLE = (formData, onProgressCallback) => {
  return new Promise((resolve, reject) => {
    axios
      .post(
        `${process.env.REACT_APP_JUPITER_URL}${process.env.REACT_APP_JUPITER_PATH}/file/upload`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: ConsumerKey,
          },
          onUploadProgress: (progressEvent) => {
            if (onProgressCallback) {
              const percentCompleted = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
              onProgressCallback(percentCompleted);
            }
          },
        }
      )
      .then((response) => {
        resolve({
          result: "success",
          data: response.data,
        });
      })
      .catch((error) => {
        console.error("Upload error:", error);
        resolve({
          result: "error",
          error: error.response ? error.response.data : "Network error",
        });
      });
  });
};

const GET_DOC_LIST = (formData) => {
  return new Promise((resolve, reject) => {
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_JUPITER_URL}${process.env.REACT_APP_JUPITER_PATH}/file`,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: ConsumerKey,
      },
      data: formData,
    };
    axios
      .request(config)
      .then((response) => {
        // console.log(JSON.stringify(response.data));
        resolve({
          result: "success",
          data: response.data,
        });
      })
      .catch((error) => {
        console.log(error);
        resolve({
          result: "error",
          error: error.response ? error.response.data : "Network error",
        });
      });
  });
};

const DOWNLOAD_REQUEST_DOC = async (formData) => {
  try {
    const config = {
      method: 'post',
      url: `${process.env.REACT_APP_JUPITER_URL}${process.env.REACT_APP_JUPITER_PATH}/file/download`,
      data: formData,
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: ConsumerKey,
      },
    };

    const response = await axios(config);

    if (response.status === 200) {
      return {
        status: response.status,
        data: response.data,
        headers: response.headers,
      };
    } else {
      throw new Error('Download failed');
    }
  } catch (error) {
    console.error('Download error:', error);
    return {
      status: error.response?.status || 500,
      message: error.message || 'An error occurred during download',
    };
  }
};

const DELETE_REQUEST_DOC = async (formData) => {
  return new Promise((resolve, reject) => {
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_JUPITER_URL}${process.env.REACT_APP_JUPITER_PATH}/file/delete`,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: ConsumerKey,
      },
      data: formData,
    };
    axios
      .request(config)
      .then((response) => {
        resolve({
          result: "success",
          data: response.data,
        });
      })
      .catch((error) => {
        console.log(error);
        resolve({
          result: "error",
          error: error.response ? error.response.data : "Network error",
        });
      });
  });
};

const POST_ADD_TRANS_FILE = async (formData) => {
  return new Promise((resolve, reject) => {
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_JUPITER_URL}${process.env.REACT_APP_JUPITER_PATH}/file/add-trans`,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: ConsumerKey,
      },
      data: formData,
    };
    axios
      .request(config)
      .then((response) => {
        resolve({
          result: "success",
          data: response.data,
        });
      })
      .catch((error) => {
        console.log(error);
        resolve({
          result: "error",
          error: error.response ? error.response.data : "Network error",
        });
      });
  });
};

const POST_DELETE_TRANS_FILE = async (formData) => {
  return new Promise((resolve, reject) => {
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_JUPITER_URL}${process.env.REACT_APP_JUPITER_PATH}/file/delete-trans`,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: ConsumerKey,
      },
      data: formData,
    };
    axios
      .request(config)
      .then((response) => {
        resolve({
          result: "success",
          data: response.data,
        });
      })
      .catch((error) => {
        console.log(error);
        resolve({
          result: "error",
          error: error.response ? error.response.data : "Network error",
        });
      });
  });
};


export { GET_ENROLLMENT_PROCESS, GET_ENROLLMENT_PROCESS_BY_ID, POST_REQUEST_DOC_MULTIPLE, GET_DOC_LIST, DOWNLOAD_REQUEST_DOC, DELETE_REQUEST_DOC, POST_ADD_TRANS_FILE, POST_DELETE_TRANS_FILE };
